import { render, staticRenderFns } from "./RegisterError.vue?vue&type=template&id=324bc427&scoped=true&"
import script from "./RegisterError.vue?vue&type=script&lang=js&"
export * from "./RegisterError.vue?vue&type=script&lang=js&"
import style0 from "./RegisterError.vue?vue&type=style&index=0&id=324bc427&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bc427",
  null
  
)

export default component.exports